exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DoughnutChart{width:100%;height:100%;display:flex;flex-direction:row}.graphOptions{width:50%;padding-top:20px}.DoughnutChart .graphDiv{width:50%}.DoughnutChart .graphDiv .gl_graphChildDiv{position:fixed;width:40%;height:65%;right:5%;top:150px}.saveGraphDataButton{display:block}.saveGraphData{float:right}input[type=text]{height:35px}.form-table th{width:25%}.vc-chrome-toggle-btn{display:none!important}.gl_colorPickerButton{background-color:#fff!important;color:#969696!important;border:1px solid #ddd!important;margin-top:2px;display:block}.vc-chrome{float:left;margin:2px 3px 0 2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-719aeef2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./admin/assets/components/DoughnutChartTemplate.vue
// module id = 44
// module chunks = 0